//before
// import React from 'react';
// import ReactDOM from 'react-dom';
import App from './App';
// ReactDOM.render(<App />,document.getElementById('root'));
//after
import { createRoot } from 'react-dom/client';

// const originalSetItem = sessionStorageSetItem;
// sessionStorageSetItem = function (key, value) {
//   const encryptedValue = CryptoJS.AES.encrypt(
//     JSON.stringify(value),
//     secretKey
//   ).toString();
//   originalSetItem.call(sessionStorage, key, encryptedValue);
// };

// const originalGetItem = sessionStorageGetItem;
// sessionStorageGetItem = function (key) {
//   const encryptedValue = originalGetItem.call(sessionStorage, key);
//   if (!encryptedValue) return null;
//   try {
//     const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);

//     return decryptData(encryptedValue);
//   } catch (error) {
//     console.error('Decryption error:', error);
//     return null;
//   }
// };

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(<App />);
